module.exports = __webpack_public_path__ + "static/Meru Health-1f96c3ffd17166562e20d33a4090126d.jpg";